@if(job.is_active) {
  <div class="match-report-div">
  <div class="match-details-left-div">
    <!-- Overall Match Report -->
    <div class="match-score-div">
      <div class="score-details">
        <p class="score-text">Match Summary</p>
        <img (mouseenter)="trackMatchSummaryInfo()" src="/assets/icons/summary/info-circle.svg" alt="external-link"  matTooltip="{{ toolTipText }}" />
      </div>
      <div class="match-quality-div">
        <img 
          src="{{getSkillCategoryIcon()}}" 
          alt="match-score"
          class="match-score-circle" 
        />
        <p class="match-quality-text">{{ getSkillCategory() }}</p>
      </div>
    </div>

    <!-- Match alignment -->
    <div class="match-skills-div">
      @for (item of matchDataAlignment; track $index) {
        <div class="match-skill-row">
          <p class="match-type-text">{{ item.title }}</p>
          <p class="match-type-dash">{{ item.dash }}</p>
          @if(getMatchSummary(item.key)) {
            <img class="match-type-img" [src]="`/assets/icons/find-job/match-square-box-${getMatchSummary(item.key)}.svg`" alt="square-box" />
          }
        </div>
      }
    </div>

  </div> 

  <!-- Aligned Skills and Skill Gaps -->
  <div class="match-data-right-div">
    <div class="skills-column-div">
      <p class="skills-title">Aligned Skills</p>
      <div class="skills-boxes">
        @if (showSkills && job.skills.length) {
          @for (item of job.skills; track $index; let i = $index) {
          @if(i < 8){ <div class="skill-box">
            <p class="skill-box-text">{{ item }}</p>
            </div>
            }
            }
        } @else {
          <div class="skill-default-box skill-box-half"></div>
          <div class="skill-default-box skill-box-full"></div>
          <div class="skill-default-box skill-box-half"></div>
          <div class="skill-default-box skill-box-half"></div>
        }
      </div>
    </div>
    @if (job.skill_gaps && job.skill_gaps.length) {
    <div class="skills-column-div">
      <p class="skills-title">Skills to Strengthen</p>
      <div class="skills-boxes">
        @if (showSkillGaps && job.skill_gaps.length) {
          @for (item of job.skill_gaps; track $index; let i = $index) {
          @if(i < 8){
              <div class="skill-gap-box">
              <p class="skill-gap-box-text">{{ item }}</p>
            </div>
          }
          }
        } @else {
          <div class="skill-default-box skill-box-full"></div>
          <div class="skill-default-box skill-box-half"></div>
          <div class="skill-default-box skill-box-full"></div>
        }
      </div>
    </div>
    }
   
    <div class="skills-column-div">
      @if (showMatchScore) {
      <div class="skills-match-type-div">
        <p class="skills-title">
          Detailed match score: {{ calculateDetailedMatchScore() }}
        </p>
    
        @if (job.related_to_career_goal) {
        <div class="match-footer-div">
          <div class="flex-row-div">
            <p class="career-goal-text">Related to career goal</p>
            <img src="/assets/icons/green-tick-star.svg" alt="tick-icon" />
          </div>
        </div> }
      </div>
    
      }
      @if ((!showMatchScore && !job.skill_gaps.length) || (showSkills && !showMatchScore)) {
      <div class="detailed-match-score-div">
        <div class="skills-title">
          Detailed match score:
        </div>
        <div class="skill-detailed-default-box"></div>
      </div>
    
    
      }
    
    </div>
    @if (!showMatchScore) {
      <button mat-flat-button type="button" class="btn" [class.btn-loading-spacing]="loading" [class.btn-margin-top]="showBtnMargin" [class.btn-skills-gap]="job.skill_gaps.length" (click)="generateRecommendations()">
        @if (!loading) {
          Generate Skills Report + Match Score
        } @else {
          <img src="assets/icons/btn-loader.svg" alt="" aria-hidden="true" class="spin" />
        }
      </button>
    }
  </div>
</div>
}
